import { createFileRoute } from "@tanstack/react-router";
import { cn } from "cn";
import * as z from "zod";
import ResponsiveWrapper from "@/components/ui/layout/box/responsive-wrapper";
import PublicLayout from "@/components/ui/layout/public-layout";
import { AuthRedirectProvider } from "@/features/auth/_providers/auth-redirect-provider";
import { ForgotPasswordOtp } from "@/features/auth/forgot-password-otp";

export const Route = createFileRoute("/(auth)/forgot-password-otp")({
  validateSearch: z.object({
    method: z.enum(["email", "phone"]),
    identifier: z.string(),
    factorId: z.string(),
    redirect_url: z.string().optional(),
  }),
  component: ForgotPasswordOtpPage,
});

function ForgotPasswordOtpPage() {
  return (
    <AuthRedirectProvider>
      <PublicLayout>
        <ResponsiveWrapper
          className={cn(
            /* sorted */
            "grow",
            "py-12",
            "sm:mx-auto sm:w-full sm:max-w-[25.5rem]",
          )}
        >
          <ForgotPasswordOtp />
        </ResponsiveWrapper>
      </PublicLayout>
    </AuthRedirectProvider>
  );
}
